export default __webpack_public_path__ + "cb42d5c109827efa22ad3c37ae123f9f.jpg";